<div
  class="message {{ intent() }}"
  [class.clickable]="clickable()"
  [tabindex]="clickable() ? 0 : null"
  (click)="clickable() ? redirect.emit() : null"
  (keydown.space)="clickable() ? redirect.emit() : null"
>
  <div class="container">
    <div class="icon">
      <ng-content select="[icon]"> </ng-content>
      <ng-content select="onyx-icon"> </ng-content>
    </div>

    @let isContentTruncated = !isExpanded() && showExpandButton();
    <div
      #contentElement
      class="content f-paragraph-s f-semibold"
      [class.hidden]="isContentTruncated"
    >
      <ng-content></ng-content>

      <div class="description f-body-m">
        <ng-content select="[description]"></ng-content>
      </div>
    </div>
  </div>

  <div class="buttons">
    @if (tooltip(); as tooltip) {
      <div class="tooltip">
        <onyx-icon
          name="tooltip-filled"
          [size]="20"
          [onyxTooltip]="tooltip"
        ></onyx-icon>
      </div>
    }

    @if (isContentTruncated && overflowHelper.hasOverflow(contentElement)) {
      <onyx-button
        variant="transparent"
        [size]="32"
        (click)="isExpanded.set(true)"
      >
        {{ `${I18N}.expand` | translate }}
      </onyx-button>
    }

    <div class="action-buttons">
      <ng-content select="onyx-button"></ng-content>
    </div>

    @if (showClose()) {
      <div class="close">
        <onyx-close-button
          class="closeButton"
          color="transparent"
          (click)="closeMessage.emit()"
        ></onyx-close-button>
      </div>
    }
  </div>
</div>
